export const STORE_PERMISSIONS = [
  { id: "dashboard", label: "Dashboard", required: true },
  { id: "products", label: "Products" },
  { id: "inventory", label: "Inventory" },
  { id: "pos", label: "POS Mode" },
  { id: "orders", label: "Orders" },
  { id: "invoices", label: "Invoices" },
  { id: "customers", label: "Customers" },
  { id: "bookings", label: "Bookings" },
  { id: "analytics", label: "Analytics" },
  { id: "settings", label: "Settings" },
] as const;

export type StorePermissionId = (typeof STORE_PERMISSIONS)[number]["id"];

export const MANUAL_MOVEMENT_TYPES = [
  { id: "restock", label: "Restock", description: "Goods received or stock added" },
  { id: "reduction", label: "Reduce stock", description: "Stock used, given away, or removed" },
  { id: "damage", label: "Damage / loss", description: "Damaged, expired, or missing items" },
  { id: "return", label: "Customer return", description: "Returned goods put back on hand" },
  { id: "count_correction", label: "Count correction", description: "Set on-hand quantity to a counted amount" },
] as const;

export const MOVEMENT_TYPE_LABELS: Record<string, string> = {
  restock: "Restock",
  reduction: "Reduce stock",
  damage: "Damage / loss",
  return: "Customer return",
  count_correction: "Count correction",
  order: "Order",
  order_cancelled: "Order cancelled",
  invoice: "Invoice",
  invoice_cancelled: "Invoice cancelled",
  pos_sale: "POS sale",
  pos_refund: "POS refund",
};

export const POS_PAYMENT_METHODS = [
  { id: "cash", label: "Cash" },
  { id: "card", label: "Card" },
  { id: "bank_transfer", label: "Bank transfer" },
  { id: "mobile_money", label: "Mobile money" },
  { id: "other", label: "Other" },
] as const;
